(ns app.front.view.group.admin.letter.condition-snippet-editor
  (:require [app.domain.application.condition.model :as condition-model]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.document-editor :as document-editor])
  (:require-macros [core.util.util :as util]))

(defn condition-snippets-editor [{:keys [visible-fragment-types
                                         get-external-edit-state-key
                                         inherited?
                                         tr
                                         images
                                         group-id
                                         document-id]}]
  (when (contains? visible-fragment-types :letter-fragment/condition-snippet)
    [document-editor/editor
     (-> (util/mmap {:title              [:h4 (tr [:letter/condition-snippet])]
                     :read-only?         inherited?
                     :placeholders       (->> condition-model/condition-snippet-variables
                                              (map :variable-name))
                     :small?             true
                     :html-fragment-type :letter-fragment/condition-snippet}
                    tr images group-id document-id)
         (text-editor/with-external-edit-state (get-external-edit-state-key :letter-fragment/condition-snippet)))]))
